import { DealerSubventionEntityIdDto } from './dealerSuibventionEntity-id-dto';

export class LoanStep3 {
    isSubventionAllowed: boolean;
    maxPayout: number = 0;
    subvention: number = 0;
    balancePayout: number = 0;
    bal: number=0;
    additionalSubvention: number=0;
    indDealerSubventionId: DealerSubventionEntityIdDto;
    dealerSubvention: number = 0;
    statusId: string = "";
    custId: string;
    productId: string;
    indusRefId: string;
    brandId: string;
    newQuotFlag : number; // flag to idnetify the type of car selected
    newVehBrandId : string; // selected bank name
    emi:number;
    interestrate:number;
  


    constructor() {
        this.indDealerSubventionId = new DealerSubventionEntityIdDto();
    }

}






